// @flow

import React, { PureComponent } from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import moment from 'moment';
import styled from 'styled-components';
import type { RouterHistory } from 'react-router';
import { i18n } from 'shared/utils';
import Table from 'shared/components/common/Table';
import BackorderStatusPill from 'shared/components/common/Pill/BackorderStatusPill';

const Wrapper = styled.div`
  padding: 0 24px;
`;

type Props = {
  history: RouterHistory,
  backorderEdges: Array<Object>,
  onCreateNew: () => void,
};

class BackordersTable extends PureComponent<Props> {
  handleRowClick = (rowData: Object) => {
    const { history } = this.props;
    history.push(`/backorder/${rowData.node.id}`);
  };

  getColumns = () => {
    const columns = [
      {
        Header: i18n.t('Backorder #'),
        accessor: 'node.backorderNumber',
        width: 140,
      },
      {
        Header: i18n.t('Order #'),
        accessor: 'node.order.orderNumber',
        width: 120,
      },
      {
        Header: i18n.t('Customer'),
        accessor: 'node.customer.name',
        minWidth: 160,
      },
      {
        Header: i18n.t('Status'),
        accessor: 'node.status',
        width: 130,
        Cell: ({ value }: *) => <BackorderStatusPill status={value} />,
      },
      {
        Header: i18n.t('Expected Date'),
        accessor: 'node.expectedDate',
        width: 140,
        Cell: ({ value }: *) => (value ? moment(value).format('MM/DD/YYYY') : '—'),
      },
      {
        Header: i18n.t('Created'),
        accessor: 'node.createdAt',
        width: 130,
        Cell: ({ value }: *) => moment(value).format('MM/DD/YYYY'),
      },
    ];

    return columns;
  };

  render() {
    const { backorderEdges } = this.props;

    if (!backorderEdges || backorderEdges.length === 0) {
      return null;
    }

    return (
      <Wrapper>
        <Table
          data={backorderEdges}
          columns={this.getColumns()}
          onRowClick={this.handleRowClick}
        />
      </Wrapper>
    );
  }
}

export default createFragmentContainer(BackordersTable, {
  backorderEdges: graphql`
    fragment BackordersTable_backorderEdges on BackorderEdge @relay(plural: true) {
      node {
        id
        backorderNumber
        status
        expectedDate
        notes
        order {
          id
          orderNumber
        }
        customer {
          id
          name
        }
        createdAt
        updatedAt
      }
    }
  `,
});
